import { TFetchConverter } from 'data/types/Converter.types';
import {
  TPropertiesSearchListUI,
  TPropertyManagementDB,
  TPropertyManagementSearchListDB,
  TPropertyManagementSearchListUI,
  TPropertyManagementUI,
  TPropertySearchDB,
  TUnitDB,
  TUnitUI,
} from 'data/types/PropertyManagement.types';

export const getPropertyManagementSearchListConvertor: TFetchConverter<
  TPropertyManagementSearchListUI[],
  TPropertyManagementSearchListDB[]
> = {
  fromDb: data =>
    data.map(item => ({
      label: item.businessName,
      value: item.id,
    })),
};

export const propertyManagementConvertor: TFetchConverter<
  TPropertyManagementUI,
  TPropertyManagementDB
> = {
  fromDb: data => ({
    name: data.name,
    logo: data.logo,
    propertyName: data.propertyName,
    unitNumber: data.unitNumber,
  }),
};

/**
 * Property names are free text: some are the street address, some are a community
 * name, and near-duplicates ("Redwood Road" and "Redwood Road II") are common.
 * Labelling an option with its address is what tells those apart, and it is also
 * what makes an address searchable in the pickers that filter these options on the
 * rendered label rather than re-querying (PP-10045).
 */
export const getPropertySearchLabel = (property: TPropertySearchDB): string =>
  property.address1 ? `${property.name} (${property.address1})` : property.name;

export const getPropertiesSearchListConvertor: TFetchConverter<
  TPropertiesSearchListUI[],
  TPropertySearchDB[]
> = {
  fromDb: data =>
    (data || []).map(item => ({
      label: getPropertySearchLabel(item),
      value: item.id,
    })),
};

export const getUnitsCoverter: TFetchConverter<TUnitUI, TUnitDB> = {
  fromDb: data => {
    return {
      name: data.number,
      value: data.id,
    };
  },
};
